import { RouteRecordRaw } from "vue-router";

// Lazy loading pour optimiser les performances
const OrderView = () => import("@/views/order/OrderView.vue");
const OrderListView = () => import("@/views/order/OrderListView.vue");
const OptionsStep = () => import("@/components/order/OptionsStep.vue");
const PaletteBanderoleGenerator = () => import("@/views/order/PaletteBanderoleGenerator.vue");

export const orderRoutes: RouteRecordRaw[] = [
  {
    path: "/order",
    component: OrderView,
    children: [
      {
        path: "",
        name: "order-list",
        component: OrderListView,
      },
      {
        path: "new",
        name: "order-new",
        component: () => import("@/views/order/OrderFormView.vue"),
      },
      {
        path: "catalog",
        name: "order-catalog",
        component: () => import("@/views/order/OrderCatalogView.vue"),
        children: [
          {
            path: "",
            name: "order-catalog-step",
            component: () => import("@/components/order/CatalogStep.vue"),
          },
          {
            path: "personalization/:orderId",
            name: "order-catalog-personalization",
            component: () =>
              import("@/views/order/OrderPersonalizationView.vue"),
            props: true,
          },
          {
            path: "dates/:orderId",
            name: "order-catalog-dates",
            component: () => import("@/views/order/OrderCatalogDatesView.vue"),
            props: true,
          },
          {
            path: "store-routing/:orderId",
            name: "order-store-routing",
            component: () => import("@/components/order/StoreRoutingStep.vue"),
            props: true,
          },
          {
            path: "options/:orderId",
            name: "order-options",
            component: OptionsStep,
            props: true,
          },
          {
            path: "summary/:orderId",
            name: "order-summary",
            component: () => import("@/components/order/SummaryStep.vue"),
            props: true,
          },
        ],
      },
      {
        path: ":id",
        name: "order-details",
        component: () => import("@/views/order/OrderDetailsView.vue"),
      },
      {
        path: ":id/edit",
        name: "order-edit",
        component: () => import("@/views/order/OrderFormView.vue"),
      },
      {
        path: "palette",
        name: "order-palette",
        component: PaletteBanderoleGenerator,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "banderoles",
        name: "order-banderoles",
        component: PaletteBanderoleGenerator,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
